import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useAtom } from 'jotai';
import { filtersAtom, filtersResetAtom } from 'global/store';
import { priceRanges } from 'global/data';
import { Box } from '@xstyled/styled-components';
import FilterType from '../FilterType';
import RadioButton from '@/UI/Form/RadioButton';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { useTranslation } from 'next-i18next';

export default function PriceFilter() {
  const { t } = useTranslation();

  const [filters, setFilters] = useAtom(filtersAtom);
  const [filtersReset, setFiltersReset] = useAtom(filtersResetAtom);

  const { register, watch, reset, setValue } = useForm();
  const priceFilter = watch('priceFilter');

  useEffect(() => {
    if (filters?.price) {
      const filter = priceRanges.find(item => {
        return JSON.stringify(item.value) === JSON.stringify(filters.price);
      });
      filter && setValue('priceFilter', filter?.name);
    }
  }, [filters?.price]);

  useEffect(() => {
    if (filtersReset) {
      reset();
      setTimeout(() => setFiltersReset(false), 1000);
    }
  }, [filtersReset]);


  return (
    <FilterType title={t('product_main.current_price')}>
      {priceRanges.map(({ name, label }) => {
        return (
          <FlexBox
            key={label}
            align="center"
            justify="space-between"
            w={240}
            lineHeight={2}
          >
            <RadioButton
              {...register('priceFilter', {
                onChange: event => {
                  const value = event.target.value;

                  const applyFilter = price => {
                    setFilters({ ...filters, price });
                    window.scrollTo(0, 0);
                  };

                  if (value === '0-99') {
                    applyFilter({ to: '99.99' });
                  } else if (value === '100-199') {
                    applyFilter({ from: '100', to: '199.99' });
                  } else if (value === '200') {
                    applyFilter({ from: '200' });
                  }
                }
              })}
              label={label}
              value={name}
              checked={priceFilter}
            />
            <Box as="span" pl={8} color="lightgray"></Box>
          </FlexBox>
        );
      })}
    </FilterType>
  );
}
